export const CONFIMEA_ASSOCIATION_REF_KEY = "confimea_association_ref";
export const CONFIMEA_DEFAULT_REFEREE = "confimeaimprese";

export const buildConfimeaAssociationUrl = (associationUsername) =>
  `https://extraconomy.com/confimeaimprese?association=${encodeURIComponent(associationUsername)}#form`;

export const storeConfimeaAssociationRef = (associationUsername) => {
  if (associationUsername) {
    sessionStorage.setItem(CONFIMEA_ASSOCIATION_REF_KEY, associationUsername);
  }
};

export const getStoredConfimeaAssociationRef = () =>
  sessionStorage.getItem(CONFIMEA_ASSOCIATION_REF_KEY);
